// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"160":"29c20d39f169798dd245","290":"c6bb365b604aa7ddcc27","344":"f8722545333a820fb8d0","700":"e94fd7801a14350d96b5","814":"67c22d9840b3e8bd492c","890":"70675281dabc53f2b6d3","938":"39f6e63487540b41e138"}[chunkId] + ".js";
};